import { storyblokEditable } from '@storyblok/react';
import { FC } from 'react';
import { SeoAccordeonStoryblok } from 'storyblok-types';
import { H1, H2, H3 } from 'atoms/Typography';
import { ReactMarkdown } from 'molecules/Markdown';
import { isValidDate, renderRichText } from 'modules/stroyblok/services';
import { AccordionWithImage, SmallContainer } from './Accordion';
import styles from './styles.module.css';

interface IBlok extends SeoAccordeonStoryblok {
  backgroundColor?: { color: string };
}

export const SeoAccordion: FC<{
  blok?: IBlok;
}> = ({ blok }) => {
  const isDateValid = isValidDate(blok?.startDate, blok?.expirationDate);

  return !blok || !isDateValid ? null : (
    <div
      className={styles.root}
      style={{ backgroundColor: blok.backgroundColor?.color }}
    >
      <SmallContainer>
        {!!blok.title && <H1 className={styles.title}>{blok.title}</H1>}
        <ul className={styles.list} {...storyblokEditable(blok)}>
          {blok?.entries?.map(
            ({ _uid, headline, image, jumpMark, textarea, isExtended }) => (
              <AccordionWithImage
                key={_uid}
                id={jumpMark}
                component="li"
                summaryContent={
                  <H2 className={styles.collapseTitle}>{headline}</H2>
                }
                defaultExpanded={isExtended}
                src={image?.filename}
                alt={image?.alt}
              >
                <ReactMarkdown
                  text={renderRichText(textarea)}
                  className={styles.text}
                  components={{
                    blockquote: ({ children }) => (
                      <blockquote className={styles.blockquote}>
                        {children}
                      </blockquote>
                    ),
                    h3: ({ children }) => (
                      <H3 className={styles.titleInText}>{children}</H3>
                    ),
                  }}
                />
              </AccordionWithImage>
            ),
          )}
        </ul>
      </SmallContainer>
    </div>
  );
};
